;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "$timeout", "$rootScope", "glTips", "glAnalytics", "StateFactory", "featureService", "projectService", "userService", "accountService", "uacService", "incentivesService", "glPrefs", "glUtils", "subscriberService", "projectSortService", "projectSearchService", "projectMatchService"];
  angular.module('app.projects').controller('Projects', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $state,
    $timeout,
    $rootScope,
    glTips,
    glAnalytics,
    StateFactory,
    featureService,
    projectService,
    userService,
    accountService,
    uacService,
    incentivesService,
    glPrefs,
    glUtils,
    subscriberService,
    projectSortService,
    projectSearchService,
    projectMatchService
  ) {
    var ctrl = this

    var SCOPES = ['active', 'archived', 'all']
    var DEFAULT_SCOPE = 'active'
    var VIEWS = ['card', 'list']
    var DEFAULT_VIEW = 'card'
    var DEBOUNCE_MS = 300
    var pending = null
    var SCOPE_LABEL = {
      active: 'Active',
      archived: 'Archived',
      all: 'All',
    }
    var SCOPE_NOUN = {
      active: 'active projects',
      archived: 'archived projects',
      all: 'projects',
    }

    var prefs = glPrefs.create('projects')
    var subscriberId = subscriberService.getSubscriber().id
    var sortPrefKey = 'sort:' + subscriberId
    var viewPrefKey = 'view:' + subscriberId

    ctrl.state = new StateFactory([
      'loading',
      'zero',
      'ready',
      'error',
      'packViewer',
    ])

    ctrl.scope = DEFAULT_SCOPE
    ctrl.searchState = new StateFactory([
      'idle',
      'searching',
      'failed',
      'settled',
    ])
    ctrl.searchState.idle()
    ctrl.query = ''
    ctrl.searchQuery = ''
    ctrl.searchHits = null
    ctrl.sort = readPref(
      sortPrefKey,
      projectSortService.isValid,
      projectSortService.DEFAULT
    )
    ctrl.view = readPref(viewPrefKey, isView, DEFAULT_VIEW)
    ctrl.sortOptions = projectSortService.OPTIONS

    ctrl.create = projectService.promptCreateAndView
    ctrl.edit = edit
    ctrl.goToProject = goToProject
    ctrl.createSurvey = createSurvey
    ctrl.goToKits = goToKits
    ctrl.setScope = setScope
    ctrl.setSort = setSort
    ctrl.setView = setView
    ctrl.setQuery = setQuery
    ctrl.retrySearch = retrySearch
    ctrl.resultsPanel = resultsPanel
    ctrl.emptyMessage = emptyMessage
    ctrl.archive = projectService.promptAndArchive
    ctrl.unarchive = projectService.promptAndUnarchive

    $scope.$on('$destroy', cancelPending)

    init()

    function init() {
      var user = userService.getUser()
      ctrl.isLoggedIn = userService.isLoggedIn()
      glAnalytics.track('projects', 'viewed', { loggedIn: ctrl.isLoggedIn })
      // TODO: re-add this when necessary
      // ctrl.isAdVisible = !_.includes(['steadfast', 'cardinia'], subscriberService.getSubscriber().subscriptionCode);
      var isPackViewer = user.initialRoute === 'analysisPacks'
      if (isPackViewer) {
        return ctrl.state.packViewer()
      }
      ctrl.state.loading()
      projectService
        .load()
        .then(function(projects) {
          ctrl.projects = projects
          ctrl.archived = projectService.getArchived()
          if (ctrl.projects.length || ctrl.archived.length) {
            if (isScope($state.params.scope)) {
              ctrl.scope = $state.params.scope
            }

            applyHits(null, '')
            $scope.$watchCollection('$ctrl.projects', recompute)
            $scope.$watchCollection('$ctrl.archived', recompute)
            ctrl.state.ready()

            if (projectSearchService.isSearchable($state.params.q)) {
              ctrl.query = $state.params.q
              runSearch()
            }
          } else {
            ctrl.zeroProjects = projectService.getZeroDetails()
            var incentiveMsg = incentivesService.getInfoMessage(
              incentivesService.Types.CREATE_PROJECT
            )
            if (incentiveMsg) {
              ctrl.zeroProjects.message += '<br><br>' + incentiveMsg
            }
            ctrl.state.zero()
          }
          glTips.ready()
        })
        .catch(function() {
          ctrl.state.error()
        })
    }

    function recompute() {
      var searching = !ctrl.searchState.isIdle()
      ctrl.allProjects = loaded()

      var hitList =
        searching && ctrl.searchHits ? _.filter(ctrl.allProjects, isHit) : null

      if (ctrl.searchHits) {
        _.each(ctrl.allProjects, function(project) {
          if (project.searchMatch === undefined) annotate(project)
        })
      }

      if (!searching) {
        ctrl.counts = {
          active: ctrl.projects.length,
          archived: ctrl.archived.length,
          all: ctrl.allProjects.length,
        }
      } else if (hitList) {
        ctrl.counts = countScopes(hitList)
      }
      ctrl.filters = _.map(SCOPES, function(scope) {
        return {
          value: scope,
          label: SCOPE_LABEL[scope],
          count: ctrl.counts[scope],
        }
      })
      // Sort runs last so any filter added before it keeps the chosen order.
      ctrl.visible = projectSortService.sort(inView(hitList), ctrl.sort)
    }

    function countScopes(list) {
      var archived = _.filter(list, 'isArchived').length
      return {
        active: list.length - archived,
        archived: archived,
        all: list.length,
      }
    }

    function inView(hitList) {
      if (ctrl.searchState.isIdle()) {
        return _.filter(ctrl.allProjects, isInScope)
      }
      if (!hitList) return []
      return _.filter(hitList, isInScope)
    }

    function loaded() {
      return ctrl.projects.concat(ctrl.archived)
    }

    function isHit(project) {
      return !!ctrl.searchHits[project.id]
    }

    function isInScope(project) {
      switch (ctrl.scope) {
        case 'active':
          return !project.isArchived
        case 'archived':
          return project.isArchived
        default:
          return true
      }
    }

    function setScope(scope) {
      if (scope === ctrl.scope) return
      ctrl.scope = scope
      syncUrl({ scope: scope === DEFAULT_SCOPE ? null : scope })
      recompute()
    }

    function readPref(key, isValid, fallback) {
      var stored = prefs.get(key, { user: true })
      return isValid(stored) ? stored : fallback
    }

    function isView(value) {
      return _.includes(VIEWS, value)
    }

    function isScope(value) {
      return _.includes(SCOPES, value)
    }

    function setQuery(value) {
      ctrl.query = value
      if (!projectSearchService.isSearchable(value)) {
        cancelPending()
        if (!ctrl.searchState.isIdle()) clearSearch()
        return
      }
      schedule()
    }

    function schedule() {
      cancelPending()
      pending = $timeout(dispatch, DEBOUNCE_MS)
    }

    function cancelPending() {
      if (!pending) return
      $timeout.cancel(pending)
      pending = null
    }

    function dispatch() {
      pending = null
      if (!projectSearchService.isSearchable(ctrl.query)) return clearSearch()

      var unchanged =
        ctrl.searchState.isSettled() &&
        projectSearchService.normalise(ctrl.query) === ctrl.searchQuery
      if (!unchanged) runSearch()
    }

    function retrySearch() {
      cancelPending()
      dispatch()
    }

    function clearSearch() {
      projectSearchService.cancel()
      ctrl.searchState.idle()
      applyHits(null, '')
      syncUrl({ q: null })
    }

    function runSearch() {
      ctrl.searchState.searching()
      applyHits(null, ctrl.searchQuery)
      syncUrl({ q: projectSearchService.normalise(ctrl.query) })
      projectSearchService.search(ctrl.query).then(onSearched, onSearchFailed)
    }

    function syncUrl(params) {
      $state.go('.', params, { location: 'replace' })
    }

    function onSearched(result) {
      ctrl.searchState.settled()
      applyHits(result.hitsById, result.query)
    }

    function onSearchFailed() {
      ctrl.searchState.failed()
      applyHits(null, ctrl.searchQuery)
    }

    function applyHits(hitsById, query) {
      ctrl.searchHits = hitsById
      ctrl.searchQuery = query
      _.each(loaded(), annotate)
      recompute()
    }

    function annotate(project) {
      var hit = ctrl.searchHits && ctrl.searchHits[project.id]
      project.searchMatch = hit
        ? projectMatchService.build(hit, ctrl.searchQuery, project.name)
        : null
    }

    function resultsPanel() {
      if (ctrl.searchState.isSearching()) return 'searching'
      if (ctrl.searchState.isFailed()) return 'failed'
      if (!ctrl.visible.length) return 'empty'
      return ctrl.view
    }

    function emptyMessage() {
      if (ctrl.searchState.isSettled()) return searchEmptyMessage()
      return ctrl.scope === 'archived'
        ? 'No archived projects.'
        : 'No active projects.'
    }

    function searchEmptyMessage() {
      var quoted = '\u201C' + ctrl.searchQuery + '\u201D'
      var elsewhere = otherScopeWithHits()
      var line = 'No ' + SCOPE_NOUN[ctrl.scope] + ' match ' + quoted
      if (!elsewhere) return line + '.'
      return (
        line +
        ' \u2014 ' +
        elsewhere.count +
        ' ' +
        elsewhere.scope +
        ' ' +
        glUtils.numberSwitch(elsewhere.count, 'does', 'do') +
        '.'
      )
    }

    function otherScopeWithHits() {
      var other = ctrl.scope === 'active' ? 'archived' : 'active'
      if (ctrl.scope === 'all' || !ctrl.counts[other]) return null
      return { scope: other, count: ctrl.counts[other] }
    }

    function setSort(value) {
      if (value === ctrl.sort) return
      ctrl.sort = value
      recompute()
      prefs.set(sortPrefKey, value, { user: true })
    }

    function setView(value) {
      if (value === ctrl.view) return
      ctrl.view = value
      prefs.set(viewPrefKey, value, { user: true })
    }

    function createSurvey() {
      if (!uacService.canManageSurveys(true)) return
      $state.go('survey', {
        surveyId: 'new',
        tab: 'editor',
      })
    }

    function edit(project) {
      if (!uacService.canManageProjects(true)) return
      projectService.edit(project)
    }

    function goToProject(project) {
      $state.go('project', { id: project.id })
    }

    function goToKits() {
      $state.go('kits')
    }
  }
})()
